if (!customElements.get('sticky-cart-summary')) {
  customElements.define(
    'sticky-cart-summary',
    class StickyCartSummary extends HTMLElement {
      connectedCallback() {
        this.totalElement = this.querySelector('[data-sticky-cart-total]');
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        window.clearTimeout(this.refreshTimer);
        this.abortController?.abort();
      }

      onCartUpdate(event) {
        const cartData = event?.cartData;

        if (this.hasCompleteCartData(cartData)) {
          this.update(cartData);
          return;
        }

        window.clearTimeout(this.refreshTimer);
        this.refreshTimer = window.setTimeout(() => this.refresh(), 100);
      }

      hasCompleteCartData(cartData) {
        return typeof cartData?.item_count === 'number' && typeof cartData?.total_price === 'number';
      }

      async refresh() {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, {
            headers: { Accept: 'application/json' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);

          this.update(await response.json());
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
        }
      }

      update(cartData) {
        this.hidden = cartData.item_count === 0;
        if (this.hidden || !this.totalElement) return;

        this.totalElement.textContent = this.formatMoney(
          cartData.total_price,
          cartData.currency || this.dataset.currency
        );
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(this.dataset.locale, {
            style: 'currency',
            currency,
          }).format(cents / 100);
        } catch (error) {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      }
    }
  );
}
